import { useState } from "react";
import './productview.css';

const ProductView = () => {
  const product = {
    name: "Giordano 00514 C60",
    price: 6480,
    image: "/path-to-image.jpg", // Update with the actual image path
    thumbnails: ["/thumb1.jpg", "/thumb2.jpg", "/thumb3.jpg"],
    description: [
      "Fixed Size Product",
      "Premium Quality Frame with Cleaning Cloth",
      "Prescription Compatible",
      "Stylish Design",
      "Warranty Available",
    ],
    installmentPrice: 1620,
  };

  const [selectedImage, setSelectedImage] = useState(product.image);
  const [selectedLens, setSelectedLens] = useState("");
  const [uploadedPrescription, setUploadedPrescription] = useState(null);

  return (
    <div className="product-container">
    {/* Left Section - Image Viewer */}
    <div>
      <img
        src={selectedImage}
        alt={product.name}
        className="product-image"
      />
      <div className="thumbnail-container">
        {product.thumbnails.map((thumb, index) => (
          <img
            key={index}
            src={thumb}
            alt="thumbnail"
            className="thumbnail"
            onClick={() => setSelectedImage(thumb)}
          />
        ))}
      </div>
    </div>
  

    {/* Right Section - Product Info */}
    <div className="product-info">
      <h1 className="product-title">{product.name}</h1>
      <p className="product-price">Rs. {product.price.toLocaleString()}</p>
      <ul className="product-description">
        {product.description.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
  
      {/* Lens Selection */}
      <div className="lens-selection">
        <label>Select Your Lens Type:</label>
        <select
          className="lens-selection-dropdown"
          onChange={(e) => setSelectedLens(e.target.value)}
        >
          <option value="">-- Please Choose --</option>
          <option value="single vision">Single Vision</option>
          <option value="progressive">Progressive</option>
        </select>
      </div>
  
      {/* Prescription Upload */}
      <div className="file-upload">
        <label>Upload Your Prescription:</label>
        <input
          type="file"
          className="file-upload-input"
          onChange={(e) => setUploadedPrescription(e.target.files[0])}
        />
      </div>
  
      {/* Add to Cart Button */}
      <button className="add-to-cart-button">
        Add to Cart
      </button>
  
      {/* Installment Payment Option */}
      <div className="installment-section">
        <p>Installment Options Available</p>
        <p className="installment-price">
          4 months installment: Rs. {product.installmentPrice.toLocaleString()}/month
        </p>
      </div>
    </div>
  </div>
  
  );
};

export default ProductView;